import axios from 'axios';
import {notify} from '@kyvg/vue3-notification';
import {debounce} from 'lodash';

export default {
    namespaced: true,

    state: () => ({
        configuration: {},
        setting: {},
        loading: false,
        loadingText: 'Carregando informações',
    }),

    mutations: {
        storeConfiguration(state, payload) {
            state.configuration = payload
        },

        storeSetting(state, payload) {
            state.setting = payload
        },

        isLoading(state, payload) {
            state.loading = payload
        },

        loadingText(state, payload) {
            state.loadingText = payload
        },
    },

    actions: {
        getConfiguration({commit}) {
            commit('isLoading', true)
            axios.get('v1/settings')
                .then(response => {
                    commit('storeConfiguration', response.data)
                    commit('storeSetting', response.data.settings)
                })
                .catch(() => {
                    notify({
                        type: 'error',
                        title: 'Oh não!',
                        text: 'Houve um erro nas configurações. Por favor, tente novamente ou acione o suporte.',
                    })
                })
                .finally(() =>
                    commit('isLoading', false),
                )
        },

        saveSetting: debounce((state, data) => {
            const payload = {setting: data.setting, value: data.value}

            axios.post(`v1/settings/${data.type}`, payload)
                .then(() => {
                    notify({
                        type: 'success',
                        title: 'Tudo certo',
                        text: 'Os ajustes foram salvas com sucesso!',
                    })
                })
                .catch(e => {
                    console.warn(e)
                    notify({
                        type: 'error',
                        title: 'Oppss...',
                        text: 'Ocorreu um erro ao salvar as configurações',
                    })
                })
        }, 1000),
    },
}